<template>
  <v-container
    v-if="workers.length > 0"
    id="workers"
    tag="section"
  >
    <base-card
      color="rgba(0, 0, 0, 0)"
      class="pa-3"
    >
      <v-container
        grid-list-xl
        pa-0
      >
        <v-layout wrap>
          <v-flex
            xs12
          >
            <base-subheading>Сотрудники организации</base-subheading>
            <v-list class="transparent"
                    v-for="(item,i) in workers">
              <v-list-tile style="height: 44px;">
                <v-list-tile-title>
                  {{item.name}}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  <v-list class="transparent">
                    <v-list-tile style="height: 44px;">
                      <v-list-tile-avatar
                        color="primary"
                      >
                        <v-icon
                          class="elevation-4"
                          dark
                        >
                          mdi-phone
                        </v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title style="width: 80px;">Тел.</v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{item.phone}}
                      </v-list-tile-sub-title>
                    </v-list-tile>
                  </v-list>
                </v-list-tile-sub-title>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </base-card>
  </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    data: function() {
      return {
        workers: []
      }
    },
    mounted () {
      axios.get('/static/data/workers.json')
        .then(response => {
          this.workers = response.data
        }).catch(error => {
          console.log(error)
        })
    }
  }
</script>
